import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
  updateWebsocketDocuments,
} from '@freelancer/datastore/core';
import { transformRawUserNotificationPreferences } from './user-notification-preferences.transformer';
import { UserNotificationPreferencesCollection } from './user-notification-preferences.types';

const NOTIFICATION_PREFERENCES_TYPE = 'userNotificationPreferences';

export function userNotificationPreferencesReducer(
  state: CollectionStateSlice<UserNotificationPreferencesCollection> = {},
  action: CollectionActions<UserNotificationPreferencesCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === NOTIFICATION_PREFERENCES_TYPE) {
        const { result, ref, order } = action.payload;

        return mergeDocuments<UserNotificationPreferencesCollection>(
          state,
          transformIntoDocuments(
            [result],
            transformRawUserNotificationPreferences,
            ref.path.authUid,
          ),
          order,
          ref,
        );
      }

      return state;
    }

    case 'API_UPDATE': {
      if (action.payload.type === NOTIFICATION_PREFERENCES_TYPE) {
        const { originalDocument, ref, delta } = action.payload;

        return updateWebsocketDocuments<UserNotificationPreferencesCollection>(
          state,
          [ref.path.authUid],
          _ => ({ ...originalDocument, ...delta }),
          ref,
        );
      }

      return state;
    }

    case 'API_UPDATE_ERROR': {
      if (action.payload.type === NOTIFICATION_PREFERENCES_TYPE) {
        const { originalDocument, ref } = action.payload;
        return mergeWebsocketDocuments<UserNotificationPreferencesCollection>(
          state,
          transformIntoDocuments([originalDocument], o => o),
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
